import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit, Input } from '@angular/core';

import { SharedProgrammingService } from './../../../common/services/shared-programming.service';
import { Event } from './../../../common/interfaces/event.interface';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';

@Component({
  selector: 'prg-flat-list',
  templateUrl: './flat-list.component.html',
  styleUrls: ['./flat-list.component.less']
})
export class FlatEventListComponent extends BaseRoutingComponent implements OnInit {
  expanded: Observable<boolean>;
  ready: Observable<boolean>;

  @Input() source: Event[];
  searchText: Observable<string>;

  constructor(
    protected router: Router,
    protected store: Store<any>,
    protected shared: SharedProgrammingService
  ) {
    super();

    this.ready = Observable.combineLatest(
      this.shared.isReady,
      this.shared.initialized,
      (ready, init) => {
        return (ready && init);
      });

    this.expanded = this.shared.listExpanded;
    this.searchText = this.shared.searchText;
  }

  ngOnInit() { }

  tileClicked(event: Event) {
    this.router.navigate(['when-then', 'device', event.deviceId, 'event', event.eventId, 'edit'], { relativeTo: this.moduleRoot });
  }

  toggleExpand() {
    this.shared.toggleListExpanded();
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-common/flat-list/flat-list.component.ts